import { FlagsmithFlags } from '@utils/flagsmith';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';

/**
 * Flagsmith gate for the V2 bulk rebalance page (`/rebalance`) and sidebar entry.
 */
export const useBulkRebalanceEnabled = (): boolean => {
  const enabled = useFeatureFlag(FlagsmithFlags.bulk_rebalance);
  return enabled;
};
